export default {
  orange: '#FBF7F2',
  darkOrange: '#F08229',
  lightOrange: '#EDB53F',
  blue: '#2196f3',
  white: '#fff',
  white50: 'rgba(255,255,255,.5)',
}
